import React, { useState, useEffect } from 'react';
import ProgressStepper from '../components/progress_bar';
import axiosInstance from "../utils/axiosInstance";
import './applications.css';
import axios from 'axios';


function Applications({user}) {
    const [applications, setApplications] = useState([]);
    const user_id = user.id;
    const API_URL = process.env.REACT_APP_ENV;;
    const progressStageMap = {
        applied: 0,
        saved: 1,
        offer: 2,
        accepted: 3,
      };
      useEffect(() => {
        const fetchApplications = async () => {
          try {
            const res = await axiosInstance.get(`${API_URL}/applications`);
            setApplications(res.data);
          } catch (err) {
            console.error("Error fetching applications:", err.response.data);
          }
        };
      
        fetchApplications();
      }, []);

    return(
        <div className='application-bg'>
            <div className = 'application-card'>
                <h1>Your Applications</h1>
                <div className='application-list'>
                  {applications.length === 0 ? (
                  <p className="no-applications-message">You haven't applied to any scholarships yet.</p>
                  ) : (
                  applications.map(app => (
                  <div key={app.title}>
                    <h3>{app.title}</h3>
                    <ProgressStepper currentStage={progressStageMap[app.progress_stage]} />
                  </div>
                  ))
                  )}
                </div>
            </div>
        </div>


    )




};

export default Applications;